import { render, staticRenderFns } from "./LmsBook.vue?vue&type=template&id=d4e9a93a&scoped=true"
import script from "./LmsBook.vue?vue&type=script&lang=js"
export * from "./LmsBook.vue?vue&type=script&lang=js"
import style0 from "./LmsBook.vue?vue&type=style&index=0&id=d4e9a93a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e9a93a",
  null
  
)

export default component.exports